import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from '../combinedReducer';

export const selectProduct = (state: ReduxApplicationState) => state.product;

export const selectProductPrice = (state: ReduxApplicationState) => state.product.price;

export const selectProductPartner = (state: ReduxApplicationState) => state.product.partner;

export const selectProductDeliveryByEvent = (state: ReduxApplicationState) =>
  state.product.deliveryByEvent;

export const selectPersonalisationOptions = createSelector(
  [selectProduct],
  (product) => product.options,
);
